import { EventTimePeriod } from '@/model/planning/EventTimePeriod'
import { Employee } from '@/model/companyStructure/Employee'
import { CompanyStructure } from '@/types'
import { CompanyFilterValue } from '@/types/payload'

export class AbsencesEditorPayload {
  private constructor (
    readonly employeeList: Array<Employee>,
    readonly eventTimePeriod: EventTimePeriod,
    readonly companyStructure: CompanyStructure,
    readonly filterValue: CompanyFilterValue
  ) {}

  public static create (
    employeeList: Array<Employee>,
    eventTimePeriod: EventTimePeriod,
    companyStructure: CompanyStructure,
    filterValue: CompanyFilterValue
  ): AbsencesEditorPayload {
    return new AbsencesEditorPayload(
      employeeList,
      eventTimePeriod,
      companyStructure,
      filterValue
    )
  }

  public static edit (
    employeeList: Array<Employee>,
    eventTimePeriod: EventTimePeriod,
    companyStructure: CompanyStructure,
    filterValue: CompanyFilterValue
  ): AbsencesEditorPayload {
    return new AbsencesEditorPayload(
      employeeList,
      eventTimePeriod,
      companyStructure,
      filterValue
    )
  }
}
